import styled from "styled-components";

export const Label = styled.p`
  font-size: 16px;
  color: #026464ff;
  margin-bottom: 10px;
`;

export const Input = styled.input`
  width: 460px;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
  margin-bottom: 10px;

  &:focus {
    border-color: #aaa;
  }
`;
